// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2S75C","content":"styles_content__1Pj_6"};